// src/plugins/okDialog.js
import { createApp } from 'vue';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import OkDialog from '../components/OkDialog.vue';

export default {
  install: (app) => {
    app.config.globalProperties.$showOkDialog = (title, message, okCallback = null) => {
      return new Promise((resolve) => {
        const container = document.createElement('div');
        document.body.appendChild(container);

        const vuetify = createVuetify({
          components,
          directives
        });

        const dialogApp = createApp(OkDialog, {
          title,
          message,
          onOk: okCallback,
          onClose: () => {
            dialogApp.unmount();
            container.remove();
            resolve();
          }
        });

        dialogApp.use(vuetify);
        dialogApp.mount(container);
      });
    };
  }
};
